import '../modules/drawer.ts'
import '../modules/search.ts'
import '../modules/toast.ts'
// import '../modules/modal.ts' //newsletter pop up logic
import '../modules/hs_forms.js'
// TODO: move carousel import only to templates that use it
import '../modules/carousel.ts'
import {
  Input,
  Carousel,
  Select,
  Dropdown,
  Ripple,
  Collapse,
  SmoothScroll,
  PerfectScrollbar,
  Offcanvas,
  Modal,
  initTE,
} from 'tw-elements'
import {
  setupActionButtonListeners,
  setupAddToCartButtonListeners,
  setupEstimateShippingButtonListeners,
  setupItemEditingListeners,
  setupClearCartButtonListener,
} from '../modules/cart'
import { setupHoverCollectionEvent } from '../modules/menu'
import '../modules/main/cookieConsent'

initTE({
  Input,
  Carousel,
  Select,
  Dropdown,
  Ripple,
  Collapse,
  SmoothScroll,
  PerfectScrollbar,
  Offcanvas,
  Modal,
})
setupActionButtonListeners()
setupItemEditingListeners()
setupAddToCartButtonListeners()
setupClearCartButtonListener()
setupHoverCollectionEvent()
setupEstimateShippingButtonListeners()
